/* Reparents the existing controls; no duplicate inputs, gallery or variant state. */
if(!customElements.get('mobile-product-layout-trial')) {
  customElements.define('mobile-product-layout-trial',class MobileProductLayoutTrial extends HTMLElement {
    connectedCallback() { this.frame=requestAnimationFrame(()=>this.setup()); }
    setup() {
      if(this.dataset.enabled!=='true') return;
      this.root=this.closest('[data-section-type="main-product"]');
      this.grid=this.root?.querySelector('.product.row');
      this.info=this.root?.querySelector('[id^="ProductInfo-"]');
      this.gallery=this.root?.querySelector('.product__media_container');
      if(!this.grid||!this.info||!this.gallery) return;
      this.titleNode=this.info.querySelector('.product__title');
      this.variants=this.info.querySelector('variant-radios,variant-selects');
      this.price=this.info.querySelector('[id^="price-"]');
      this.terms=this.price?.nextElementSibling?.querySelector('form.installment')?.parentElement;
      this.guide=this.info.querySelector('modal-opener[data-modal^="#ProductSizeGuide-"]')?.closest('.product_additional_information');
      this.mediaColumn=this.gallery.parentElement;
      this.infoColumn=this.info.parentElement;
      this.skip=this.gallery.querySelector('.skip-to-content-link');
      this.skipHref=this.skip?.getAttribute('href');
      this.mql=matchMedia('(max-width:749px)');
      this.onChange=()=>this.mql.matches?this.move():this.restore();
      this.mql.addEventListener('change',this.onChange);
      this.onChange();
    }
    slot(name,before) {
      const slot=document.createElement('div');slot.className='mobile-trial-slot mobile-trial-'+name+'-slot';
      this.grid.insertBefore(slot,before);this.slots.push(slot);return slot;
    }
    keep(node,slot) {
      if(!node) return;
      const anchor=document.createComment('Original mobile trial position');node.before(anchor);
      this.positions.push({node,anchor});slot.append(node);
    }
    move() {
      if(this.active) return;
      this.positions=[];this.slots=[];
      const heading=(this.titleNode||this.price)?this.slot('title',this.mediaColumn):null;
      if(heading){this.keep(this.titleNode,heading);this.keep(this.price,heading);this.keep(this.terms,heading);}
      const variants=this.variants?this.slot('variant',this.infoColumn):null;
      if(variants) this.keep(this.variants,variants);
      const guide=this.guide?(variants||this.slot('variant',this.infoColumn)):null;
      if(guide) this.keep(this.guide,guide);
      const skipTarget=variants||guide;
      if(skipTarget) {
        skipTarget.id='MobileProductOptions-'+this.root.dataset.sectionId;skipTarget.tabIndex=-1;
        this.skip?.setAttribute('href','#'+skipTarget.id);
      }
      this.root.setAttribute('data-mobile-layout-trial-active','');this.active=true;
    }
    restore() {
      if(!this.active) return;
      this.positions.forEach(({node,anchor})=>{if(anchor.parentNode)anchor.replaceWith(node);});
      this.slots.forEach(slot=>slot.remove());
      if(this.skipHref) this.skip?.setAttribute('href',this.skipHref);
      this.root?.removeAttribute('data-mobile-layout-trial-active');this.active=false;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);this.mql?.removeEventListener('change',this.onChange);this.restore();
    }
  });
}
